import { StateCreator } from "zustand";

export enum UserDataTabNames {
    "My Searches" = "My Searches",
    "My Notifications" = "My Notifications",
    "My Tracks" = "My Tracks",
}

export interface UserCollectedDataTabsSlice {
    userCollectedDataTab: UserDataTabNames;
    setUserCollectedDataTab: (tab: UserDataTabNames) => void;
}

const initialUserCollectedDataTabState: UserDataTabNames = UserDataTabNames["My Searches"];

export const createUserCollectedDataTabsSlice: StateCreator<UserCollectedDataTabsSlice, [], [], UserCollectedDataTabsSlice> = (set) => ({
    userCollectedDataTab: initialUserCollectedDataTabState,
    setUserCollectedDataTab: (tab) => set({ userCollectedDataTab: tab }),
});

